import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import './globals.css';
import { installAppLaunchSplashGuards } from './lib/pwa/app-launch';
import { installStaleChunkRecovery } from './lib/stale-chunk-recovery';
import { router } from './routes';

installStaleChunkRecovery();
installAppLaunchSplashGuards();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
